"use client"

import fetchInterceptorInClient from "@/components/fetcher/fetchInterceptorInClient"
import {
  resultPostprocessing2,
} from "@/components/fetcher/fetchInterceptor"
import { FolderListResponse } from "../../../entities/FolderEntity"

const ROOT = process.env.NEXT_PUBLIC_ROOT

const fetchClientFolderList = (size?: number) =>
  fetchInterceptorInClient(
    {
      method: "get",
      credentials: "same-origin",
    },
    ROOT,
  )(() => `/api/notebook/folders/my`, {
    ...(size && { size }),
  }).then(
    resultPostprocessing2<FolderListResponse>,
  )
export default fetchClientFolderList
